import usePrivateLink from "../config/usePrivateLink";
import React, { useEffect, useState } from 'react'
import { courseDelete} from '../../api/Courses';
import { Link, useNavigate } from 'react-router-dom';
import DownloadExcel from '../master/DownloadExcel';
import Header from '../master/SideBar';
import Nav from '../master/NavBar';
import Swal from 'sweetalert2';
import { closeModal, ToastMain,SweetAlertShow } from '../master/Master';
import { CreateCategory, fetchCategories, updateCategory } from '../../api/Documents';
import DocumentHeader from './DocumentHeader';

const DocumentCategory = () => {
  const hasAccess = usePrivateLink();
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [subjects, setSubjects] = useState([]);
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const[error, setError]=useState('')
  
  const categoryCreate = async (e) => {
    e.preventDefault();
    setLoading(true)

    try {
      const formData = new FormData(e.target);

      
      
      const response = await CreateCategory(formData);

      if (response?.data?.status) {
        setError('')
        closeModal("editUser");
        categoryFetch();
        SweetAlertShow('success','Successfully',response?.data?.message)
     
      } else {
        if(response?.data?.errors){
          setError(response?.data?.errors)
        }
        SweetAlertShow('info','Warning',response?.data?.message)
        
      }
    } catch (error) {
       if(error?.response?.data?.errors){
          setError(error?.response?.data?.errors)
        }
        SweetAlertShow('error','Error',error?.response?.data?.message ??   error?.response?.message ?? error?.message)
    
    }finally{
      setLoading(false)
    }
  };

  const updateStatus = async (id, status) => {
    setLoading(true)
    try {
      const formData = new FormData();
      formData.append("id", id);       // 🔹 Title ki id
      formData.append("status", status); // 🔹 0 ya 1

      const response = await updateCategory(formData); // 👈 API call
      if (response?.data?.status) {
        ToastMain.fire({
          icon: "success",
          title: "Status Updated!",
        }).then(() => {
          categoryFetch();
        })
      } else {
        SweetAlertShow('info','Warning',response?.data?.message)
       
      }
    } catch (error) {
      SweetAlertShow('error','Error',error?.response?.data?.message ?? error?.response?.message ?? error?.message)
     
    }finally{
      setLoading(false)
    }
  };


  const categoryFetch = async () => {
    setLoading(true); // 🌀 Show loading spinner
    try {
      const response = await fetchCategories();
      if (response.data.status) {
        setCourses(response?.data?.data);
        console.log('api. chali gyi', response?.data)
      } else {
        SweetAlertShow('info','Warning',response?.data?.message)
      
      }
    } catch (error) {
      SweetAlertShow('error' ,error?.response?.data?.message ?? error?.response?.message ?? error?.message)
     
    }finally{
      setLoading(false)
    }
   
  };

  const handleCourseDelete = async (id) => {
    setLoading(true); // 🌀 Show loading spinner
    try {
      const response = await courseDelete(id);
      if (response.data.status) {
        categoryFetch();
        SweetAlertShow('sucess','Successfully',response?.data?.message)
        // ToastMain.fire({
        //   icon: "success",
        //   title: "Delete Successfully!",
        // });
      } else {
        SweetAlertShow('info','Warning', response?.data?.message )
       
      }
    } catch (error) {
      SweetAlertShow('error','Error',error?.response?.data?.message ?? error?.response?.message ?? error?.message)
     
    }
    setLoading(false); // 🌀 Hide loading spinner
  };


  useEffect(() => {
    categoryFetch();
  }, []);

  const handleDownload = () => {
    setLoading(true);

    // const transformations = [
    //   { type: 'add', newKey: 'Time', value: '000000' },
    //   { type: "rename", oldKey: "VEH_NO", newKey: "Vehicle Number" },
    // ];

    DownloadExcel(
      courses,
      ["status", "created_at", "updated_at"],
      "Courses_Classes_list",
      []
    );

    setLoading(false);
  };
const typeLabels = {
    enquiry: "Enquiry",
    marketing: "Marketing",
    admitted: "Admitted",
  };

  return (
    <>

          {loading && (
        <div
          className="d-flex justify-content-center align-items-center position-fixed top-0 start-0 w-100 h-100"
          style={{ zIndex: 9999 }}
        >
          <div className="sk-chase sk-primary display-1">
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
          </div>
        </div>
      )}
      <div className="layout-wrapper layout-content-navbar">

        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-fluid mt-2">
               <div className="row custom-scroll-pane">
                
                  <div className="col-md-2 left-pane">
                    <DocumentHeader data={'Document Portal'}/>
                  </div>
                  <div className="col-md-10 right-pane">
                     <div className="card">
                  <div className="card-header d-flex align-items-center justify-content-between">
                    <h4 className="text-primary m-0">Document Category</h4>
                    <div className=" d-flex gap-1">
                      {hasAccess('/documents/category/add') && (
                        <button
                          className="btn btn-primary btn-sm"
                          data-bs-toggle="modal"
                          data-bs-target="#editUser"

                        >
                          <i className="bi bi-plus-circle-dotted me-2"></i> Add Document
                          Category
                        </button>
                      )}
                     
                      {/* {(permissions?.[0]?.role_id == '1' || permissions?.find((permission) => permission?.route?.frontend_url == '/course/export')) && (
                        <button
                          className="btn btn-success btn-sm"
                          onClick={handleDownload}
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          title="Export Excel"
                        >
                          <i className="bi bi-cloud-arrow-down ri-20px"></i>
                        </button>
                      )} */}
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="table-responsive">
                      <table className="table table-hover table-bordered align-middle text-center">
                        <thead className="table-light">
                          <tr>
                            <th style={{ width: "60px" }}>#</th>
                            <th className="text-start">Category Name</th>
                            <th className="text-start">Discription</th>
                            <th style={{ width: "120px" }}>Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          {courses.length === 0 ? (
                            <tr>
                              <td colSpan="3" className="text-center">
                                No courses available
                              </td>
                            </tr>
                          ) : (
                            courses.map((item, index) => (
                              <tr key={item.id}>
                                <td>{index + 1}</td>
                                <td className="text-start">{item.title}</td>
                                <td className="text-start">
                                  {(() => {
                                    try {
                                      // Parse JSON string into array
                                      const arr = JSON.parse(item.type);

                                      // Map to readable labels
                                      return arr.map((t) => typeLabels[t] || t).join(", ");
                                    } catch (e) {
                                      // Fallback in case it's not valid JSON
                                      return typeLabels[item.type] || item.type;
                                    }
                                  })()}
                                </td>

                                <td>
                                  {hasAccess('/documents/category/status') && (
                                  <div
                                    onClick={() => {
                                      const newStatus = item.status === "1" ? "0" : "1";
                                      updateStatus(item.id, newStatus);
                                    }}
                                    style={{
                                      width: "50px",
                                      height: "25px",
                                      borderRadius: "20px",
                                      backgroundColor:
                                        item.status === "1" ? "green" : "gray",
                                      position: "relative",
                                      cursor: "pointer",
                                      transition: "0.3s",
                                      margin: "auto", // ✅ Center align toggle
                                    }}
                                  >
                                    <div
                                      style={{
                                        width: "22px",
                                        height: "22px",
                                        borderRadius: "50%",
                                        background: "white",
                                        position: "absolute",
                                        top: "1.5px",
                                        left: item.status === "1" ? "26px" : "2px",
                                        transition: "0.3s",
                                      }}
                                    ></div>
                                  </div>
                                  )}
                                </td>
                              </tr>
                            ))
                          )}
                        </tbody>
                      </table>
                    </div>

                  </div>
                </div>
                  </div>
              
               </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="modal fade" id="editUser" tabIndex={-1} aria-hidden="true">
        <div className="modal-dialog modal-lg modal-edit-user">
          <div className="modal-content">
            <div className="modal-body p-3">
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
              <div className="text-center mb-6">
                <h4 className="mb-2">Category</h4>
              </div>
              <form
                id="editUserForm"
                className="row g-5 fv-plugins-bootstrap5 fv-plugins-framework"
                onSubmit={categoryCreate}
                noValidate
              >
                <div className="col-12 col-md-12 fv-plugins-icon-container">
                  <div className="form-floating form-floating-outline">
                    <input
                      type="text"
                      id="modalEditUserFirstName"
                      name="title"
                      className="form-control input-capitalize"
                      placeholder="Category"
                    />
                    <label htmlFor="modalEditUserFirstName">Category</label>
                    <span className='text-danger'>{error?.title ?? ''}</span>
                  </div>
                  <div className="fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback" />
                </div>
                <div className="col-12 col-md-12 fv-plugins-icon-container">
                  <div className="form-floating form-floating-outline">
                    <input
                      type="text"
                      id="modalEditUserFirstName"
                      name="title"
                      className="form-control input-capitalize"
                      placeholder="Discription"
                    />
                    <label htmlFor="modalEditUserFirstName">Discription</label>
                    <span className='text-danger'>{error?.discription ?? ''}</span>
                  </div>
                  <div className="fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback" />
                </div>

                {/* Category Checkboxes */}
                {/* <div className="col-12 mb-3">
                  <label className="form-label">Select Categories</label>

                  <div>
                    <input
                      type="checkbox"
                      id="marketing"
                      value="marketing"
                      checked={selectedCategories.includes("marketing")}
                      onChange={handleCheckboxChange}
                    />
                    <label htmlFor="marketing" className="ms-2">
                      Marketing
                    </label>
                    
                  </div>

                  <div>
                    <input
                      type="checkbox"
                      id="marketingEnquiry"
                      value="enquiry"
                      checked={selectedCategories.includes("enquiry")}
                      onChange={handleCheckboxChange}
                    />
                    <label htmlFor="enquiry" className="ms-2">
                      Enquiry
                    </label>
                  </div>

                  <div>
                    <input
                      type="checkbox"
                      id="admitted"
                      value="student"
                      checked={selectedCategories.includes("student")}
                      onChange={handleCheckboxChange}
                    />
                    <label htmlFor="student" className="ms-2">
                      Student
                    </label>
                  </div>
                </div> */}

                <div className="col-12 text-center">
                     <button
                  type="submit"
                  className="btn btn-primary px-5 me-2"
                  disabled={loading}  // Disable the button while loading
                >
                  {loading ? (
                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  ) : (
                    'Submit'
                  )}
                  {loading ? ' Submitting...' : ''}
                </button>
                  <button
                    type="reset"
                    className="btn btn-outline-secondary waves-effect"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  >
                    Cancel
                  </button>
                </div>
                {/* <input type="hidden" /> */}
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default DocumentCategory
